module.exports = __webpack_public_path__ + "img/error-500-lg.33c27610.jpg";